<div class="container-fluid">
	<div class="row">
		<div class="col-12">
			<div class="page_header">
				<h1 class="heading">Data Extracts</h1>
			</div>
			<!-- <div class="cover-x" style="position: absolute; right: 3px; top: -1px; z-index: 9;">
				<div class="main-btn rounded-circle rmp-all" (click)="back()" title="Go back"
					style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
					<span class="fa fa-arrow-left fa-2x" style="margin:5.5px auto;color:white!important;"
						aria-hidden="true"></span>
				</div>
				<div class="lbl-app" style="margin: 1px auto;">
					<span>Back</span>
				</div>
			</div>
			<hr /> -->
			<div style="height: 100vh; width: 100%;  border: 0; box-shadow: 0;">
				<iframe style="border: 0; box-shadow: 0;" [src]="iframeUrl" height="100%" width="100%"
					name="ifRptListing">
					<p>Your browser does not support iframes.</p>
				</iframe>
			</div>
		</div>
	</div>
</div>